import type { SearchBoxVM } from '@/react/view-models/SearchBoxVM';
import type { VoidCallback } from '@/type-utils';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import { ProductsBySearch } from './internal/ProductsBySearch';
import { SuggestedProducts } from './internal/SuggestedProducts';

export interface IProductSuggestionsProps {
  /**
   * The `SearchBoxVM` instance to be used.
   */
  vm: SearchBoxVM;

  /**
   * The function to be called when the user navigates to a new page.
   */
  onNavigate: VoidCallback;
}

/**
 * A simple wrapper to select the correct product suggestions based on the search term and
 * the results available.
 */
export const ProductSuggestions: FC<IProductSuggestionsProps> = observer(
  (props) => {
    const { vm } = props;

    // If there are suggestions for the current search term, show them.
    if (vm.productSuggestionsByTerm.length > 0) {
      return <ProductsBySearch {...props} />;
    }

    // Otherwise, show the suggested products.
    return <SuggestedProducts {...props} />;
  }
);
